import { t } from "@/i18n";
export function getTestAndBundleOptions(testList, discountPanelList) {
  let result = [];
  // get Discount Panel
  let discountPanelOptions = (
    discountPanelList
  ).map((panel) => {
    return { id: panel.bundleId, name: panel.bundleName };
  });
  result.push({
    label: t("OrderPage[\"DISCOUNT PANEL\"]"),
    options: discountPanelOptions,
  });

  // get Test Panel and Single Test for va and vw tests
  let testOptions = testList.map((test) => {
    return { id: test.id, name: test.testName, type: test.type };
  });
  let groupOptions = testOptions.filter(
    (option) => option.type === "GROUP"
  );
  let singleTestOptions = testOptions.filter(
    (option) => option.type === "TEST"
  );
  result.push({
    label: t("OrderPage[\"TEST PANEL\"]"),
    options: groupOptions,
  });
  result.push({
    label: t("OrderPage[\"SINGLE TEST\"]"),
    options: singleTestOptions,
  });
  return result;
}

// get items that are affected by switching the toggle
// and categorized them into three lists: discard, different price, and same price
export function getAffectedItemLists(dbsToggle, supportObj) {
  let { selectedTestList, selectedDiscountPanelList, selectedCustomPanelList, selectedXChooseYPanelList, selectedSeasonalPromoList, dbsMap, testList, bundleList, selectedShortcutList, editOrderItemList=[] } = supportObj;
  let discardItemList = [];
  let differentPriceItemList = [];
  let samePriceItemList = [];
  if (dbsToggle) {
    // for edit order, trigger dialog if prev ordered test is from va panel
    editOrderItemList.forEach((test) => {
      if (test.category === "va") {
        discardItemList.push({
          id: test.item_id,
          category: test.category,
          name: test.item_name,
          fromPrice: test.total.toFixed(2),
          toPrice: "Discard"
        });
      } 
    })
    // discard all custom panels
    selectedCustomPanelList.forEach(panel => {
      discardItemList.push({
          id: panel.bundleId,
          category: panel.category,
          name: panel.bundleName,
          fromPrice: panel.price.toFixed(2),
          toPrice: "Discard",
          serumPanel: panel
      });
    })
    // find any selected shortcuts need to be discard when switch to dbs menu
    selectedShortcutList.forEach(shortcut => {
      let { blood, dryIce } = shortcut.sampleTypeSets;
      if (blood.size > 0 || dryIce.size > 0) {
        discardItemList.push({
          id: shortcut.id,
          category: shortcut.category,
          name: shortcut.shortcutName,
          fromPrice: shortcut.price.toFixed(2),
          toPrice: "Discard"
        });
      }
    });
    // find any tests/bundles need to be discard or converted to different price dbs version
    selectedTestList.forEach((test) => {
      if (test.category === "va") {
        discardItemList.push({
          id: test.id,
          category: test.category,
          name: test.testName,
          fromPrice: test.price.toFixed(2),
          toPrice: "Discard"
        });
      } else {
        let hasDbsVersion = dbsMap.find((dbs) => dbs.originalItemId === test.id);
        if (hasDbsVersion) {
          // check price whether same, if different, add to differentPriceItemList
          let dbsTest = testList.find((t) => t.id === hasDbsVersion.dbsItemId);
          if (dbsTest) {
            // check whether the dbs version is selectable
            if (dbsTest.isNotAllowedSelect) {
              discardItemList.push({
                id: test.id,
                category: test.category,
                name: test.testName,
                fromPrice: test.price.toFixed(2),
                toPrice: "Discard"
              });
            } else if (dbsTest.price.toFixed(2) !== test.price.toFixed(2)) {
              differentPriceItemList.push({
                fromId: test.id,
                toId: dbsTest.id,
                name: test.testName,
                category: test.category,
                fromPrice: test.price.toFixed(2),
                toPrice: dbsTest.price.toFixed(2),
              });
            }
            else {
              samePriceItemList.push({
                fromId: test.id,
                toId: dbsTest.id,
                serumTest: test,
                dbsTest,
                category: test.category,
              });
            }
          }
          else {
            discardItemList.push({
              id: test.id,
              name: test.testName,
              fromPrice: test.price.toFixed(2),
              toPrice: "Discard",
              category: test.category,
            });
          }
        } else {
          // check whether the test should be discard when switch to dbs version
          let { blood, dryIce } = test.sampleTypeSets;
          if (blood.size > 0 || dryIce.size > 0) {
            discardItemList.push({
              id: test.id,
              name: test.testName,
              fromPrice: test.price.toFixed(2),
              toPrice: "Discard",
              category: test.category,
            });
          }
        }
      }
    });
    // find any tests/bundles need to be discard or converted to different price dbs version
    selectedDiscountPanelList.forEach((panel) => {
      let hasDbsVersion = dbsMap.find((dbs) => dbs.originalItemId === panel.bundleId);
      if (hasDbsVersion) {
        // check price whether same, if different, add to differentPriceItemList
        let dbsPanel = bundleList.find((b) => b.bundleId === hasDbsVersion.dbsItemId);
        if (dbsPanel) {
          if (dbsPanel.price.toFixed(2) !== panel.price.toFixed(2)) {
            differentPriceItemList.push({
              fromId: panel.bundleId,
              toId: dbsPanel.bundleId,
              name: panel.bundleName,
              category: panel.category,
              fromPrice: panel.price.toFixed(2),
              toPrice: dbsPanel.price.toFixed(2),
            });
          }
          else {
            samePriceItemList.push({
              fromId: panel.bundleId,
              toId: dbsPanel.bundleId,
              serumPanel: panel,
              dbsPanel: dbsPanel,
              category: panel.category,
            });
          }
        }
        else {
          discardItemList.push({
            id: panel.bundleId,
            name: panel.bundleName,
            fromPrice: panel.price.toFixed(2),
            toPrice: "Discard",
            category: panel.category,
          });
        }
      } else {
        // check whether the test should be discard when switch to dbs version
        let { blood, dryIce } = panel.sampleTypeSets;
        if (blood.size > 0 || dryIce.size > 0) {
          discardItemList.push({
            id: panel.bundleId,
            name: panel.bundleName,
            fromPrice: panel.price.toFixed(2),
            toPrice: "Discard",
            category: panel.category,
          });
        }
      }
    });
    // find any x choose y bundles need to convert
    selectedXChooseYPanelList.forEach((panel) => {
      let hasDbsVersion = dbsMap.find((dbs) => dbs.originalItemId === panel.bundleId && dbs.type === "bundle");
      if (hasDbsVersion) {
        let dbsPanel = bundleList.find(
          (b) => b.bundleId === hasDbsVersion.dbsItemId
        );
        // process zoomer IDs: keep tests that exist in both menus, convert and filter others
        let dbsZoomerIds = [];
        if (panel.selectedZoomerIdList) {
          panel.selectedZoomerIdList.forEach((zoomerId) => {
            let hasDbsMapping = dbsMap.find((dbs) => dbs.originalItemId === zoomerId);
            if (hasDbsMapping) {
              // test needs conversion, check if DBS version is selectable
              let dbsId = hasDbsMapping.dbsItemId;
              let dbsTest = testList.find((t) => t.id === dbsId);
              if (dbsTest && !dbsTest.isNotAllowedSelect) {
                dbsZoomerIds.push(dbsId);
              }
            } else {
              // test exists in both menus, treat as eligible
              let test = testList.find((t) => t.id === zoomerId);
              if (test && test.section === "both" && !test.isNotAllowedSelect) {
                dbsZoomerIds.push(zoomerId);
              }
            }
          });
        }
        // process supplement IDs: keep tests that exist in both menus, convert and filter others
        let dbsSupplementIds = [];
        if (panel.selectedSupplementIdList) {
          panel.selectedSupplementIdList.forEach((supplementId) => {
            let hasDbsMapping = dbsMap.find((dbs) => dbs.originalItemId === supplementId);
            if (hasDbsMapping) {
              // test needs conversion, check if DBS version is selectable
              let dbsId = hasDbsMapping.dbsItemId;
              let dbsTest = testList.find((t) => t.id === dbsId);
              if (dbsTest && !dbsTest.isNotAllowedSelect) {
                dbsSupplementIds.push(dbsId);
              }
            } else {
              // test exists in both menus, treat as eligible
              let test = testList.find((t) => t.id === supplementId);
              if (test && test.section === "both" && !test.isNotAllowedSelect) {
                dbsSupplementIds.push(supplementId);
              }
            }
          });
        }
        let isInPool = dbsZoomerIds.concat(dbsSupplementIds).every(id => dbsPanel.testIdsInPanel.find(b => b === id));
        if (!isInPool ||
          dbsSupplementIds.length !== panel.selectedSupplementIdList.length ||
          dbsZoomerIds.length !== panel.selectedZoomerIdList.length
        ) {
          discardItemList.push({
            id: panel.bundleId,
            category: panel.category,
            name: panel.bundleName + " " + t("OrderPage[\"(unsupport supplement)\"]"),
            fromPrice: panel.price.toFixed(2),
            toPrice: "Discard",
            serumPanel: panel,
          });
        }
        else {
          dbsPanel.selectedZoomerIdList = dbsZoomerIds;
          dbsPanel.selectedSupplementIdList = dbsSupplementIds;
          if (panel.price.toFixed(2) !== dbsPanel.price.toFixed(2)) {
            differentPriceItemList.push({
              fromId: panel.bundleId,
              toId: dbsPanel.bundleId,
              name: panel.bundleName,
              category: panel.category,
              fromPrice: panel.price.toFixed(2),
              toPrice: dbsPanel.price.toFixed(2),
              dbsPanel,
              serumPanel: panel,
            });
          } else {
            samePriceItemList.push({
              fromId: panel.bundleId,
              toId: dbsPanel.bundleId,
              serumPanel: panel,
              dbsPanel,
              category: panel.category,
            });
          }
        }
      } else {
        // panel has no dbs version, discard when switching to dbs menu
        discardItemList.push({
          id: panel.bundleId,
          category: panel.category,
          name: panel.bundleName,
          fromPrice: panel.price.toFixed(2),
          toPrice: "Discard",
          serumPanel: panel,
        });
      }
    });
    // find any seasonal panel that need to convert or discard
    selectedSeasonalPromoList.forEach(promo => {
      // check each bundle in the selected promo
      promo.appliedBundles.forEach(bundleId => {
        let hasDbsVersion = dbsMap.find((dbs) => dbs.originalItemId === bundleId);
        if (hasDbsVersion) {
          let dbsPanel = bundleList.find(panel => panel.bundleId === hasDbsVersion.dbsItemId);
          if (dbsPanel) { // if bundle has dbs version
            if (dbsPanel.price.toFixed(2) === promo.finalAmount.toFixed(2)) {
              samePriceItemList.push({
                fromId: bundleId,
                toId: dbsPanel.bundleId,
                dbsPanel,
                serumPanel: promo,
                category: promo.category,
              });
            }
            else {
              differentPriceItemList.push({
                fromId: bundleId,
                toId: dbsPanel.bundleId,
                category: promo.category,
                name: promo.discountName,
                fromPrice: promo.finalAmount.toFixed(2),
                toPrice: dbsPanel.price.toFixed(2),
                dbsPanel,
                serumPanel: promo
              });
            }
          }
          else {
            // bundle doesn't have dbs version, discard
            discardItemList.push({
              id: promo.bundleId,
              name: promo.discountName,
              fromPrice: promo.finalAmount.toFixed(2),
              toPrice: "Discard",
              category: promo.category,
              promo
            })
          }
        }
        else {
          let panel = bundleList.find(panel => panel.bundleId === bundleId);
          // check whether the test should be discard when switch to dbs version
          let { blood, dryIce } = panel.sampleTypeSets;
          if (blood.size > 0 || dryIce.size > 0) {
            discardItemList.push({
              id: promo.bundleId,
              name: promo.discountName,
              fromPrice: promo.finalAmount.toFixed(2),
              toPrice: "Discard",
              category: promo.category,
              promo
            });
        }
      }
      })
    });
  } else {
    // discard all custom panels
    selectedCustomPanelList.forEach(panel => {
      discardItemList.push({
        id: panel.bundleId,
        category: panel.category,
        name: panel.bundleName,
        fromPrice: panel.price.toFixed(2),
        toPrice: "Discard",
        dbsPanel: panel
      });
    })
    // discard all dbs shortcuts when switch to nondbs shortcuts
    selectedShortcutList.filter(shortcut => shortcut.isDbs).forEach(shortcut => {
      discardItemList.push({
        id: shortcut.id,
        category: shortcut.category,
        name: shortcut.shortcutName,
        fromPrice: shortcut.price.toFixed(2),
        toPrice: "Discard"
      });
    });
    // temporarily discard all seasonal promos
    selectedSeasonalPromoList.forEach(panel => {
      discardItemList.push({
        id: panel.bundleId,
        category: panel.category,
        name: panel.discountName,
        fromPrice: panel.price.toFixed(2),
        toPrice: "Discard",
        promo: panel
    });
    })
    // find any tests need to convert from dbs to serum version
    selectedTestList.forEach((test) => {
      let hasSerumVersion = dbsMap.find((dbs) => dbs.dbsItemId === test.id);
      if (hasSerumVersion) {
        // check price whether same, if different, add to differentPriceItemList
        let serumTest = testList.find((t) => t.id === hasSerumVersion.originalItemId);
        if (serumTest) {
          // check whether the serum version is selectable
          if (serumTest.isNotAllowedSelect) {
            discardItemList.push({
              id: test.id,
              category: test.category,
              name: test.testName,
              fromPrice: test.price.toFixed(2),
              toPrice: "Discard"
            });
          } else if (serumTest.price.toFixed(2) !== test.price.toFixed(2)) {
            differentPriceItemList.push({
              fromId: test.id,
              toId: serumTest.id,
              category: test.category,
              name: test.testName,
              fromPrice: test.price.toFixed(2),
              toPrice: serumTest.price.toFixed(2),
            });
          } else {
            samePriceItemList.push({
              fromId: test.id,
              toId: serumTest.id,
              serumTest,
              dbsTest: test,
              category: test.category,
            });
          }
        }
        else {
          discardItemList.push({
            id: test.id,
            name: test.testName,
            fromPrice: test.price.toFixed(2),
            toPrice: "Discard",
            category: test.category,
          });
        }
      } else {
        // test has no serum version, discard when switching to serum menu
        let { nonBlood } = test.sampleTypeSets;
        if (nonBlood && nonBlood.has("DBS")) {
          discardItemList.push({
            id: test.id,
            name: test.testName,
            fromPrice: test.price.toFixed(2),
            toPrice: "Discard",
            category: test.category,
          });
        }
      }
    });
    // find any bundles need to convert from dbs to serum version
    selectedDiscountPanelList.forEach((panel) => {
      let hasSerumVersion = dbsMap.find((dbs) => dbs.dbsItemId === panel.bundleId);
      if (hasSerumVersion) {
        // check price whether same, if different, add to differentPriceItemList
        let serumPanel = bundleList.find((b) => b.bundleId === hasSerumVersion.originalItemId);
        if (serumPanel) {
          if (serumPanel.price.toFixed(2) !== panel.price.toFixed(2)) {
            differentPriceItemList.push({
              fromId: panel.bundleId,
              toId: serumPanel.bundleId,
              category: panel.category,
              name: panel.bundleName,
              fromPrice: panel.price.toFixed(2),
              toPrice: serumPanel.price.toFixed(2),
            });
          } else {
            samePriceItemList.push({
              fromId: panel.bundleId,
              toId: serumPanel.bundleId,
              serumPanel,
              dbsPanel: panel,
              category: panel.category,
            });
          }
        }
        else {
          discardItemList.push({
            id: panel.bundleId,
            name: panel.bundleName,
            fromPrice: panel.price.toFixed(2),
            toPrice: "Discard",
            category: panel.category,
          });
        }
      } else {
        // panel has no serum version, discard when switching to serum menu
        let { nonBlood } = panel.sampleTypeSets;
        if (nonBlood && nonBlood.has("DBS")) {
          discardItemList.push({
            id: panel.bundleId,
            name: panel.bundleName,
            fromPrice: panel.price.toFixed(2),
            toPrice: "Discard",
            category: panel.category,
          });
        }
      }
    });
    // find any x choose y panel need to convert to serum version
    selectedXChooseYPanelList.forEach((panel) => {
      let hasSerumVersion = dbsMap.find((dbs) => dbs.dbsItemId === panel.bundleId);
      if (hasSerumVersion) {
        let serumPanel = bundleList.find((b) => b.bundleId === hasSerumVersion.originalItemId);
        // process zoomer IDs: keep tests that exist in both menus, convert and filter others
        let serumZoomerIds = [];
        if (panel.selectedZoomerIdList) {
          panel.selectedZoomerIdList.forEach((zoomerId) => {
            let hasSerumMapping = dbsMap.find((dbs) => dbs.dbsItemId === zoomerId);
            if (hasSerumMapping) {
              // test needs conversion, check if serum version is selectable
              let serumId = hasSerumMapping.originalItemId;
              let serumTest = testList.find((t) => t.id === serumId);
              if (serumTest && !serumTest.isNotAllowedSelect) {
                serumZoomerIds.push(serumId);
              }
            } else {
              // test exists in both menus, treat as eligible
              let test = testList.find((t) => t.id === zoomerId);
              if (test && test.section === "both" && !test.isNotAllowedSelect) {
                serumZoomerIds.push(zoomerId);
              }
            }
          });
        }
        // process supplement IDs: keep tests that exist in both menus, convert and filter others
        let serumSupplementIds = [];
        if (panel.selectedSupplementIdList) {
          panel.selectedSupplementIdList.forEach((supplementId) => {
            let hasSerumMapping = dbsMap.find((dbs) => dbs.dbsItemId === supplementId);
            if (hasSerumMapping) {
              // test needs conversion, check if serum version is selectable
              let serumId = hasSerumMapping.originalItemId;
              let serumTest = testList.find((t) => t.id === serumId);
              if (serumTest && !serumTest.isNotAllowedSelect) {
                serumSupplementIds.push(serumId);
              }
            } else {
              // test exists in both menus, treat as eligible
              let test = testList.find((t) => t.id === supplementId);
              if (test && test.section === "both" && !test.isNotAllowedSelect) {
                serumSupplementIds.push(supplementId);
              }
            }
          });
        }
        let isInPool = serumZoomerIds.concat(serumSupplementIds).every(id => serumPanel.testIdsInPanel.find(b => b === id));
        if (!isInPool || 
            serumZoomerIds.length !== panel.selectedZoomerIdList.length ||
            serumSupplementIds.length !== panel.selectedSupplementIdList.length) {
          discardItemList.push({
            id: panel.bundleId,
            category: panel.category,
            name: panel.bundleName,
            fromPrice: panel.price.toFixed(2),
            toPrice: "Discard",
          });
        } else {
          serumPanel.selectedZoomerIdList = serumZoomerIds;
          serumPanel.selectedSupplementIdList = serumSupplementIds;
          if (serumPanel.price.toFixed(2) !== panel.price.toFixed(2)) {
            differentPriceItemList.push({
              fromId: panel.bundleId,
              toId: serumPanel.bundleId,
              category: panel.category,
              name: panel.bundleName,
              fromPrice: panel.price.toFixed(2),
              toPrice: serumPanel.price.toFixed(2),
              serumPanel,
              dbsPanel: panel,
            });
          } else {
            samePriceItemList.push({
              fromId: panel.bundleId,
              toId: serumPanel.bundleId,
              serumPanel,
              dbsPanel: panel,
              category: panel.category
            });
          }
        }
      } else {
        // panel has no serum version, discard when switching to serum menu
        discardItemList.push({
          id: panel.bundleId,
          category: panel.category,
          name: panel.bundleName,
          fromPrice: panel.price.toFixed(2),
          toPrice: "Discard",
          dbsPanel: panel,
        });
      }
    });
    // find any seasonal panel that need to convert or discard
    // selectedSeasonalPromoList.forEach(promo => {
    //   // check each bundle in the selected promo
    //   promo.appliedBundles.forEach(bundleId => {
    //     let hasSerumVersion = dbsMap.find(map => map.dbsItemId === bundleId);
    //     if (hasSerumVersion) {
    //       let serumPanel = bundleList.find(panel => panel.bundleId === hasSerumVersion.originalItemId);
    //       if (serumPanel) { // if bundle has serum version
    //         if (serumPanel.price.toFixed(2) === promo.finalAmount.toFixed(2)) {
    //           samePriceItemList.push({
    //           serumPanel,
    //           dbsPanel: promo,
    //           category: promo.category,
    //         });
    //         }
    //         else {
    //           differentPriceItemList.push({
    //             fromId: bundleId,
    //             toId: serumPanel.bundleId,
    //             category: promo.category,
    //             name: promo.discountName,
    //             fromPrice: promo.finalAmount.toFixed(2),
    //             toPrice: serumPanel.price.toFixed(2),
    //             dbsPanel: promo,
    //             serumPanel
    //           });
    //         }
    //       }
    //       else {
    //         // bundle doesn't have serum version, discard
    //         discardItemList.push({
    //           id: promo.bundleId,
    //           name: promo.discountName,
    //           fromPrice: promo.finalAmount.toFixed(2),
    //           toPrice: "Discard",
    //           category: promo.category,
    //           promo
    //         })
    //       }
    //     }
    //   })
    // })
  }
  return { discardItemList, differentPriceItemList, samePriceItemList };
}